<template>
  <div class="trustpilot">
    <h3 v-if="title"
        class="trustpilot__title">
      {{ title }}
    </h3>
    <div
      ref="trustbox"
      class="trustpilot-widget"
      data-locale="fr-FR"
      data-businessunit-id="4ec0e70b00006400051186d3"
      data-style-width="100%"
      :data-theme="theme"
      data-stars="5"
      :data-template-id="template"
      :data-style-height="height">
      <a
        href="https://fr.trustpilot.com/review/nextories.com"
        target="_blank" rel="noopener">
        Trustpilot
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'trustpilot',
  props: {
    title: {
      type: String,
      default: '',
    },
    template: {
      type: String,
      default: '53aa8912dec7e10d38f59f36',
    },
    height: {
      type: String,
      default: '140px',
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  mounted() {
    if (!window.Trustpilot) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      document.head.appendChild(script);
    } else {
      window.Trustpilot.loadFromElement(this.$refs.trustbox);
    }
  },
};
</script>

<style scoped lang="scss">
.trustpilot {
  &__title {
    text-transform: uppercase;
    font-weight: $--font-weight-600;
    margin-top: 0;
    margin-bottom: 30px
  }
}
</style>
